import { AiGenerateTestButton } from './ai-generate-test-button';
import { NewTestButton } from './new-test-button';

export const TestCreationButtons = (): JSX.Element => (
	<>
		<NewTestButton />
		<AiGenerateTestButton />
	</>
);
